import { createContext, useContext } from 'react';

type ClassRefreshFn = () => void;

export const ClassRefreshContext = createContext<ClassRefreshFn | null>(null);

export const useClassRefresh = () => useContext(ClassRefreshContext);
